var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import DiscountReason from './Model';
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (data) {
            _this.data = data.map(function (value) { return new DiscountReason(value); });
            _this.loaded = true;
            return _this.data;
        };
        this.push = function (data) {
            _this.data.push(new DiscountReason(data));
            return _this.data;
        };
        this.replace = function (data) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === data.id; }), 1, data);
        };
        this.pull = function (value) {
            _this.data.splice(_this.data.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    default_1.prototype.create = function (data) {
        return api.post('discountreasons', data).then(this.push);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch("discountreasons/".concat(id), { disabled: disabled }).then(this.pull);
    };
    default_1.prototype.read = function (id) {
        if (id)
            return api.get("discountreasons/".concat(id));
        return api.get('discountreasons').then(this.set);
    };
    default_1.prototype.update = function (id, data) {
        return api.put("discountreasons/".concat(id), data)
            .then(this.replace);
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountReasons/Store.tsx
// module id = 719
// module chunks = 0